import axiosInstance from './axios';

const StatisticsAPI = {

    getStatisticsData : (listing, lang) => {
        return axiosInstance.get(`statistics/${listing}/${lang}`, { });
    },
   


}

export default StatisticsAPI;